App = {

	debug: false,
	hasDirectory: false,

	init: function () {
	},

	initScroll: function() {
		$(".page-content").scroll(function() {
			var scrollValue = $(".page-content").scrollTop();
			
			if (scrollValue > 170) {
				$(".row.header").addClass("scrolled");
				$(".page-content").addClass("scrolled");
			} else {
				$(".scrolled").removeClass("scrolled");
			}
		});
	},

	loadFonts: function(){
		return new Promise(function(resolve, reject) {
			try{
				Typekit.load({
					async: true,
					active: resolve,
					inactive: resolve
				});
			}
			catch(e){
				resolve();
			}
		});
	},

	winLoaded: function(){
		 return new Promise(function(resolve, reject) {
		 	$(window).load(resolve);
		 });
	},
	
	
}
